import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { func, objectOf, shape, string } from 'prop-types';
import RadioField from '#component/form/radio';
import { isoDateOnlyGen } from '#component/project/form/helper';
import { toMeta } from '#helper/rhf-meta';
import { StyledDateField } from '#component/project/form/project/field-styles';

const radioData = {
  items: [
    { id: 0, value: '0', label: 'Forever' },
    { id: 1, value: '1', label: 'Specific date' }
  ]
};

/**
 * Renders begin and expirationDate date fields.
 * Renders radio buttons to select expirationDate date.
 * @returns {React.ReactFragment}
 */

const DateFields = props => {
  const {
    minMaxDate,
    formData,
    change,
    initialValues: {
      disableFieldsInRoot,
      disableIsExpirationDate
    },
    forceError
  } = props;

  const { control, formState } = useFormContext();

  const maxBeginDate = Date.parse(formData.expirationDate) ?
    formData.expirationDate : minMaxDate.maxDate;
  const maxExpirationDate = Date.parse(formData.beginDate) ?
    formData.beginDate : minMaxDate.maxDate;

  const handleIsExpirationDateChange = event => {
    if (event.target.value === '1') {
      change('expirationDate', isoDateOnlyGen(new Date()));
    } else {
      change('expirationDate', null);
    }
  };

  return (
    <>
      <Controller
        name="beginDate"
        control={control}
        render={({ field, fieldState }) => (
          <StyledDateField
            {...field}
            meta={toMeta(fieldState, formState)}
            label="Begin date"
            disabled={disableFieldsInRoot}
            variant="outlined"
            fullWidth
            minDate={minMaxDate.minDate}
            maxDate={maxBeginDate}
            dateonly={true}
            forceError={forceError}
          />
        )}
      />
      <Controller
        name="isExpirationDate"
        control={control}
        render={({ field, fieldState }) => (
          <RadioField
            {...field}
            value={field.value ?? '0'}
            meta={toMeta(fieldState, formState)}
            label="End date"
            disabled={disableIsExpirationDate}
            data={radioData}
            onChange={event => {
              field.onChange(event);
              handleIsExpirationDateChange(event);
            }}
          />
        )}
      />
      {formData.isExpirationDate === '1' && (
        <Controller
          name="expirationDate"
          control={control}
          render={({ field, fieldState }) => (
            <StyledDateField
              {...field}
              meta={toMeta(fieldState, formState)}
              label="End date"
              disabled={disableFieldsInRoot}
              variant="outlined"
              fullWidth
              minDate={maxExpirationDate}
              maxDate={minMaxDate.maxDate}
              dateonly={true}
              forceError={forceError}
            />
          )}
        />
      )}
    </>
  );
};

DateFields.propTypes = {
  minMaxDate: objectOf(string),
  formData: shape({}).isRequired,
  change: func.isRequired
};

export default DateFields;
